'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIControllable;

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropNames = require('../core/PropNames');

var _reactUtils = require('react-utils');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_FIELDS = ['value'];
var DISPLAY_NAME_PREFIX = 'Controllable';

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {Object}
 */
function _getDefaultProps(component, fields) {
  // shallow copy of defaultProps to use as the initial value to prevent mutation
  var defaultProps = _extends({}, component.defaultProps);

  return fields.reduce(function (defaults, field) {
    if (defaults.hasOwnProperty(field)) {
      defaults[(0, _PropNames.getDefaultPropName)(field)] = defaults[field];
      delete defaults[field];
    }
    return defaults;
  }, defaultProps);
}

/**
 * @param  {Object}
 * @param  {Array<string>}
 * @return {Object}
 */
function getDefaultPropTypes(originalPropTypes, fields) {
  return fields.reduce(function (propTypes, field) {
    if (typeof propTypes[field] !== 'function') {
      propTypes[field] = _react.PropTypes.any;
    }
    propTypes[(0, _PropNames.getDefaultPropName)(field)] = propTypes[field];
    return propTypes;
  }, (0, _underscore.clone)(originalPropTypes) || {});
}

/**
 * @param  {React.Component}
 * @return {string}
 */
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * @param  {React.Component} component
 * @param  {string} field
 * @param  {Object} event
 * @return {void}
 */
function handleChange(component, field, evt) {
  if (!component.isMounted()) {
    return;
  }

  (0, _reactUtils.invariant)(evt && evt.target != null, getDisplayName(component.constructor) + ' handleChange: expected ' + 'argument in shape of SyntheticEvent ({target: value})');

  component.setState(_defineProperty({}, field, evt.target.value));
  var onChange = component.props[(0, _PropNames.getOnChangeName)(field)];
  if (typeof onChange === 'function') {
    onChange(evt);
  }
}

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {React.Component}
 */
function UIControllable(InputComponent) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FIELDS;

  var onChangeKeys = (0, _underscore.map)(fields, _PropNames.getOnChangeName);
  var defaultProps = (0, _underscore.map)(fields, _PropNames.getDefaultPropName);

  var controlledComponent = _react2.default.createClass({
    displayName: DISPLAY_NAME_PREFIX + '(' + getDisplayName(InputComponent) + ')',

    propTypes: getDefaultPropTypes(InputComponent.propTypes, fields),

    /**
     * @return {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return _getDefaultProps(InputComponent, fields);
    },


    /**
     * @return {Object}
     */
    getInitialState: function getInitialState() {
      var defaults = (0, _underscore.pick)(this.props, defaultProps);
      var initialState = {};
      Object.keys(defaults).forEach(function (defaultKey) {
        initialState[(0, _PropNames.getPropFromDefaultName)(defaultKey)] = defaults[defaultKey];
      });

      return initialState;
    },


    /**
     * @return {void}
     */
    componentWillMount: function componentWillMount() {
      var _this = this;

      var handlers = {};
      onChangeKeys.forEach(function (onChangeKey, i) {
        handlers[onChangeKey] = (0, _underscore.partial)(handleChange, _this, fields[i]);
      });
      this.handlers = handlers;
    },


    /**
     * @return {Object}
     */
    getProps: function getProps() {
      return _extends({}, this.state, (0, _underscore.omit)(this.props, defaultProps), this.handlers);
    },


    /**
     * @return {void}
     */
    copyMethods: function copyMethods(wrappedInstance) {
      var _this2 = this;

      // Copy all methods from the wrapped component instance to this wrapper,
      // so that this wrapper is usable as a ref.
      if (!wrappedInstance) {
        return;
      }
      Object.getOwnPropertyNames(wrappedInstance).forEach(function (key) {
        if (typeof wrappedInstance[key] === 'function' && !_this2[key]) {
          _this2[key] = wrappedInstance[key];
        }
      });
    },


    /**
     * @return {React.Element}
     */
    render: function render() {
      return _react2.default.createElement(InputComponent, _extends({}, this.getProps(), {
        ref: this.copyMethods
      }));
    }
  });

  controlledComponent.WrappedComponent = InputComponent;
  controlledComponent.CoreComponent = (0, _utils.getCoreComponent)(InputComponent);

  return controlledComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/decorators/Controllable.js
// module id = 56
// module chunks = 0 1